'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dropbox = dropbox;

var _dropboxDropins = require('vendor/dropbox-dropins.src');

var _dropboxDropins2 = _interopRequireDefault(_dropboxDropins);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function dropbox() {
  return (0, _dropboxDropins2.default)();
}


//////////////////
// WEBPACK FOOTER
// ./src/utils/dropbox-dropins.js
// module id = 2244
// module chunks = 1